import { render, staticRenderFns } from "./thirdFormSet.vue?vue&type=template&id=06088c82&scoped=true&"
import script from "./thirdFormSet.vue?vue&type=script&lang=js&"
export * from "./thirdFormSet.vue?vue&type=script&lang=js&"
import style0 from "./thirdFormSet.vue?vue&type=style&index=0&id=06088c82&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06088c82",
  null
  
)

export default component.exports